import CategoryIcon from '@mui/icons-material/Category';
import { Alert, Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { CustomAccordion } from '../../../components/CustomAccordion';
import { type Veranstaltung } from '../../../dtos';

type VeranstaltungsAusstattungVAProps = {
  readonly veranstaltung: Veranstaltung;
};

export const VeranstaltungsAusstattungVAComponent = ({ veranstaltung }: VeranstaltungsAusstattungVAProps) => {
  const material = veranstaltung.material.filter((aus) => aus.verwendung === 'Veranstaltung');

  return (
    <CustomAccordion title="Ausstattung Veranstaltung" open={false} icon={CategoryIcon}>
      {material.length === 0 ? (
        <Alert severity="info">Kein Veranstaltungs-Material vorhanden</Alert>
      ) : (
        <TableContainer component={Box}>
          <Table size="small" sx={{ borderSpacing: 0, borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow
                sx={{ 'td, th': { padding: 0, paddingRight: '4px', paddingLeft: '4px', paddingBottom: '2px' } }}
              >
                <TableCell>ID</TableCell>
                <TableCell>Materialbezeichnung</TableCell>
                <TableCell>Anzahl</TableCell>
                <TableCell>Zuständig</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {material.map((ausstattung) => (
                <TableRow
                  key={ausstattung.id}
                  sx={{
                    'td, th': {
                      border: 0,
                      padding: 0,
                      paddingRight: '4px',
                      paddingLeft: '4px',
                      paddingBottom: '2px',
                      verticalAlign: 'top',
                    },
                  }}
                >
                  <TableCell>{ausstattung.id}</TableCell>
                  <TableCell>{ausstattung.bezeichnung}</TableCell>
                  <TableCell>{ausstattung.anzahl}</TableCell>
                  <TableCell>{ausstattung.zustaendigkeit}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </CustomAccordion>
  );
};
